module.exports = __webpack_public_path__ + "img/SIKH RED.ba75265.svg";